import { ICard } from 'interfaces/components/card';

const Card = ({ value, description, onUpdate, className }: ICard) => {
  return (
    <div
      className={`flex flex-col gap-2 items-start w-[218px] pl-6 py-4 border-l-[2px] border-l-gray-200 flex-1 ${className}`}
    >
      <div className='flex flex-row w-full justify-between items-center'>
        <p className='text-[32px] font-semibold whitespace-nowrap'>{value}</p>
        {value === 'N/A' && (
          <p
            className='text-sm text-gray-500 cursor-pointer hover:underline whitespace-nowrap'
            onClick={onUpdate}
          >
            Update data
          </p>
        )}
      </div>

      <p className='font-light text-gray-700 whitespace-nowrap'>
        {description}
      </p>
    </div>
  );
};

export default Card;
